import { openInquiryLayer } from '@/lib/reduxToolkit/inquiry';
import { $, Header } from "@/util/util";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logistics_section1_data, logistics_section2_data, logistics_section3_data, logistics_section4_amazon_data, logistics_section5_pricing_data } from './PageLogistics.data';

function PageLogistics({title}) {
  Header.setLogoColor('white')

  const dispatch = useDispatch();

  const [isPc, setIsPc] = useState(window.innerWidth >= 1280);

  useEffect(() => {
    const handleResize = () => {
      const nowIsPc = window.innerWidth >= 1280;
      setIsPc(nowIsPc);

      // ✅ 즉시 스타일 초기화 (resize 순간)
      if (!nowIsPc) {
        const leftText = document.getElementById("leftText");
        if (leftText) {
          leftText.style.position = "relative";
          leftText.style.top = "auto";
          leftText.style.left = "auto";
          leftText.style.width = "auto";
          leftText.style.opacity = "1";
          leftText.style.transform = "translateY(0)";
        }

        const cardContainer = document.getElementById("cardContainer");
        if (cardContainer) cardContainer.style.transform = "translateY(0)";
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const container = document.getElementById("cardContainer");
    if (!container) return;

    const wrapper = container.closest("section");
    if (!isPc) {
      container.style.transform = "translateY(0px)";
      return;
    }
    if (!wrapper) return;

    const onScroll = () => {
      const rect = wrapper.getBoundingClientRect();
      const sectionHeight = rect.height - window.innerHeight;

      if (rect.top >= 0) {
        container.style.transform = "translateY(0px)";
        return;
      }
      if (rect.bottom <= 0) {
        container.style.transform = "translateY(-400px)";
        return;
      }

      const progress = Math.min(
        Math.max((window.innerHeight - rect.top) / sectionHeight, 0),
        1
      );
      container.style.transform = `translateY(${-progress * 400}px)`;
    };

    window.addEventListener("scroll", onScroll);
    requestAnimationFrame(() => setTimeout(onScroll, 100));

    return () => window.removeEventListener("scroll", onScroll);
  }, [isPc]);

  /** ✅ 왼쪽 텍스트 고정 (PC 전용) */
  useEffect(() => {
  const leftText = document.getElementById("leftText");
  if (!leftText) return;

  /** ✅ 모바일 모드일 경우: 즉시 초기화 */
  if (!isPc) {
    leftText.style.position = "relative";
    leftText.style.top = "auto";
    leftText.style.left = "auto";
    leftText.style.width = "auto";
    leftText.style.opacity = "1";
    leftText.style.transform = "translateY(0)";
    return;
  }

  /** ✅ PC 모드 로직 */
  const section1 = document.getElementById("section1");
  const wrapper = document.getElementById("leftTextWrapper");
  if (!section1 || !wrapper) return;

  let initialLeft = 0;
  let initialWidth = 0;

  const updateInitialValues = () => {
    const wrapperRect = wrapper.getBoundingClientRect();
    initialLeft = wrapperRect.left + window.scrollX;
    initialWidth = wrapperRect.width;
  };

  updateInitialValues();

  const handleScroll = () => {
    const sectionTop = section1.offsetTop;
    const sectionHeight = section1.offsetHeight;
    const sectionBottom = sectionTop + sectionHeight;
    const scrollY = window.scrollY;
    const textHeight = leftText.offsetHeight;
    const fadeStart = sectionBottom - textHeight - 300;
    const fadeEnd = sectionBottom - textHeight - 50;

    if (scrollY < sectionTop) {
      leftText.style.position = "relative";
      leftText.style.opacity = "1";
      leftText.style.transform = "translateY(0)";
      return;
    }

    if (scrollY >= sectionTop && scrollY < fadeStart) {
      leftText.style.position = "fixed";
      leftText.style.top = "120px";
      leftText.style.left = `${initialLeft}px`;
      leftText.style.width = `${initialWidth}px`;
      leftText.style.opacity = "1";
      leftText.style.transform = "translateY(0)";
      return;
    }

    if (scrollY >= fadeStart && scrollY < fadeEnd) {
      const progress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
      leftText.style.position = "fixed";
      leftText.style.top = "120px";
      leftText.style.left = `${initialLeft}px`;
      leftText.style.width = `${initialWidth}px`;
      leftText.style.opacity = `${1 - progress}`;
      leftText.style.transform = `translateY(${progress * 40}px)`;
      return;
    }

    if (scrollY >= fadeEnd) {
      leftText.style.position = "relative";
      leftText.style.opacity = "0";
      leftText.style.transform = "translateY(40px)";
      return;
    }
  };

  /** ✅ 별도 resize 핸들러 (cleanup 가능하도록 분리) */
  const handleResize = () => {
    updateInitialValues();
    handleScroll();
  };

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleResize);

  handleScroll(); // 초기 실행

  return () => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleResize);
  };
}, [isPc]);

  return (
    <div data-title={title} className={`PageLogistics overflow-hidden xl:overflow-auto`}>
      <section className="relative xl:overflow-hidden xl:min-h-screen" id="section1">
        <div
          className={`
            xl:bg-fixed
            bg-cover bg-center
            pt-[140px] xl:pt-[111px]
            pb-[80px] xl:pb-0 
            bg-[url('@/assets/image/img-19-01.png')]
            xl:bg-[url('@/assets/image/img-19-01.png')]
            text-white
            overflow-visible
            xl:h-auto
          `}
        >
          <div className="w-[1280px] m-auto px-0 relative flex flex-col xl:flex-row items-start justify-between">
            {/* 왼쪽 텍스트 */}
            <div className="relative w-full xl:w-[35%] px-[20px] mb-[40px] xl:mb-0" id="leftTextWrapper">
              <div id="leftText" className="relative flex flex-col justify-center gap-[16px] xl:transition-all xl:duration-500 xl:ease-out">
                <div className="xl:pt-[80px]">
                  <div 
                    className="text-[14px] xl:text-[16px] font-semibold leading-[16px] xl:leading-[24px] mb-[18px]"
                    data-aos='fade-up'
                  >
                    TOTAL CROSSBOARDER SOLUTION
                  </div>
                  <div 
                    className="font-semibold text-[24px] leading-[36px] xl:text-[48px] xl:leading-[56px] mb-[28px] xl:mb-[60px]"
                    data-aos='fade-up'
                    data-aos-delay={200}
                  >
                    고객의 주문 여정을<br />단 하나의 솔루션으로
                  </div>
                  <div 
                    className="text-[16px] leading-[26px] xl:text-[18px] xl:leading-[26px]"
                    data-aos='fade-up'
                    data-aos-delay={300}
                  >
                    주문부터 통관, 배송까지 모든 과정을 자동화한<br />
                    통합솔루션으로 더 정확하고 신뢰할 수 있는<br />
                    물류 경험을 만듭니다.
                  </div>
                </div>
              </div>
            </div>

            {/* 카드 리스트 (이제 전체 스크롤) */}
            <div
              id="cardContainer"
              className="
                relative
                flex flex-row gap-6 flex-nowrap
                overflow-x-auto scroll-smooth
                scrollbar-none
                xl:overflow-x-visible xl:grid xl:grid-cols-2 xl:gap-6
                w-screen px-[16px] xl:w-auto xl:px-0
              "
            >
              {logistics_section1_data.map((card, index) => (
                <section
                  key={index}
                  className={`
                    group relative flex-shrink-0
                    w-[272px] h-[400px] xl:w-[380px] xl:h-[560px]
                    bg-center bg-cover
                    flex flex-col items-start justify-end
                    rounded-[12px] overflow-hidden text-white
                    px-[24px] py-[48px]
                    shadow-[0px_10px_30px_0px_#00000014]
                    transition-transform duration-700
                    ${index % 2 === 1 ? 'xl:translate-y-[80px]' : ''}
                  `}
                  style={{
                    backgroundImage: `url(${require(`@/assets/image/img-19-01-0${index + 1}.png`)})`,
                  }}
                >
                  <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-[0.4] transition-opacity duration-500 ease-out"></div>
                  <div className="relative z-10 flex flex-col gap-[8px] transition-transform duration-700 ease-in-out">
                    <div className="text-[18px] leading-[32px]">{card.subTitle}</div>
                    <div className="text-[36px] leading-[44px] font-bold">{card.title}</div>
                    <div
                      className="
                        overflow-hidden
                        max-h-0 opacity-0
                        group-hover:max-h-[500px] group-hover:opacity-100
                        transition-all duration-700 ease-in-out
                        flex flex-col gap-[4px] mt-[8px]
                      "
                    >
                      {card.desc.map((text, idx) => (
                        <div
                          key={idx}
                          className='relative text-[14px] pl-[25px] leading-[24px]
                          before:content-["•"] before:absolute before:left-[7px] before:top-0
                          before:text-[12px] before:leading-[24px]'
                        >
                          {text}
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section id="section2" className='bg-[linear-gradient(180deg,_#00528C_0%,_#132648_100%)] text-white py-[80px] xl:py-[140px]'>
        <div className='flex flex-col items-center text-center justify-center gap-[60px] lg:gap-[140px]'>
          {
            logistics_section2_data.map((v, index) => {
              return <article key={index} 
                className='flex flex-col'
              >
                <div 
                  className='flex flex-col gap-[12px] xl:gap-[18px] mb-[40px]'
                  data-aos='fade-up'
                  data-aos-delay={index * 200}
                >
                  <div className='text-[14px] leading-[16px] uppercase font-semibold xl:text-[16px] xl:leading-[24px]'>{v.subTitle}</div>
                  <div className='text-[24px] leading-[36px] font-semibold xl:text-[48px] xl:leading-[56px]'>{v.title}</div>
                </div>
                <div 
                  className={`ONLY-DESKTOP mb-[28px]`}
                  data-aos='fade-up'
                  data-aos-delay={index * 200 + 150}
                  style={{
                    backgroundImage: `url(${require(`@/assets/image/img-19-02-0${index + 1}-pc.png`)})`,
                    backgroundSize: '100% 100%',
                    width: index === 0 ? '1110px' : index === 1 ? '1020px' : '1020px',
                    height: index === 0 ? '604px' : index === 1 ? '607px' : '596px',
                  }}
                ></div>
                <div 
                  className={`ONLY-MOBILE`} 
                  data-aos='fade-up'
                  data-aos-delay={index * 200 + 150}
                  style={{
                    backgroundImage: `url(${require(`@/assets/image/img-19-02-0${index + 1}-mo.png`)})`,
                    backgroundSize: '100% 100%',
                    width: '328px',
                    height: index === 0 ? '543px' : index === 1 ? '482px' : '494px',
                  }}
                ></div>
                <div className='mt-[28px] text-[14px] leading-[24px] xl:text-[24px] xl:leading-[36px]' 
                  data-aos='fade-up'
                  data-aos-delay={index * 200 + 170}
                >{v.desc}</div>
              </article>
            })
          }
        </div>
      </section>
      <section id="section3" className='bg-white pt-[80px] xl:pt-[180px] pb-[80px] xl:pb-[140px]'>
        <div className='INSIDE relative'>
          <article className='flex flex-col gap-[20px] xl:gap-[8px] mb-[60px] xl:mb-[80px]'>
            <div  className="text-black flex flex-col xl:flex-row xl:items-center xl:justify-between gap-[12px] xl:gap-0">
              <div 
                className='font-semibold text-[36px] leading-[44px] xl:text-[72px] xl:leading-[76px]'
                data-aos='fade-up'
                data-aos-delay={200}
              >
                Information
              </div>
              <div 
                data-aos='fade-up'
                data-aos-delay={400}
                className='text-[24px] font-semibold xl:text-right leading-[36px] xl:text-[36px] xl:leading-[44px]'
              >
                커머스온 솔루션 <br />세부기능을 소개합니다
              </div>
            </div>
            <div 
              data-aos='fade-up'
              data-aos-delay={500}
              className='text-[16px] leading-[26px] xl:text-[20px] xl:leading-[30px]'
            >
              각 메뉴별 핵심 기능을 담았습니다.<br />하나의 솔루션으로 모든 물류 흐름을 자동 관리하며, 더 빠르고 스마트한 글로벌 커머스를 실현합니다.
            </div>
          </article>
          <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-[40px] gap-[20px]">
            {
              logistics_section3_data.map((v, index) => {
                return <div 
                  key={index} 
                  className={`bg-cover xl:w-[620px] xl:h-[372px] w-full min-w-[328px] h-[216px] m-auto text-white flex flex-col items-start justify-end pl-[24px] pb-[32px] xl:pl-[60px] xl:pb-[60px] gap-[8px] xl:gap-[20px]`}
                  style={{
                    backgroundImage: `url(${require(`@/assets/image/img-19-03-0${index + 1}.png`)})`,
                  }}
                  data-aos='fade-up'
                  data-aos-delay={index * 200}
                >
                  <div className='text-[24px] leading-[36px] xl:text-[36px] xl:leading-[44px] font-semibold'>{v.title}</div>
                  <div className='text-[16px] leading-[26px] xl:text-[18px]'>{v.subTitle}</div>
                </div>
              })
            }
          </div>
        </div>
      </section>
      {/* Section 4: Amazon D2C 솔루션 */}
      <section id="section4" className="bg-[#F4F8FC] pt-[80px] xl:pt-[140px] pb-[80px] xl:pb-[140px]">
        <div className="INSIDE">
          <div className="flex flex-col items-center text-center mb-[60px] xl:mb-[80px]">
            <span
              className="inline-block bg-[#00528C] text-white text-[12px] xl:text-[14px] font-semibold px-[16px] py-[8px] rounded-full mb-[24px] tracking-[0.08em]"
              data-aos="fade-up"
            >
              {logistics_section4_amazon_data.badge}
            </span>
            <h2
              className="font-semibold text-[32px] leading-[44px] xl:text-[56px] xl:leading-[68px] text-[#132648] mb-[16px] whitespace-pre-line"
              data-aos="fade-up"
              data-aos-delay={100}
            >
              {logistics_section4_amazon_data.title}
            </h2>
            <p
              className="text-[#00528C] text-[14px] xl:text-[16px] font-semibold mb-[20px]"
              data-aos="fade-up"
              data-aos-delay={150}
            >
              {logistics_section4_amazon_data.subtitle}
            </p>
            <p
              className="text-[#444] text-[15px] leading-[26px] xl:text-[18px] xl:leading-[30px] max-w-[760px]"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              {logistics_section4_amazon_data.description}
            </p>
          </div>

          {/* 4단계 프로세스 */}
          <div
            className="flex flex-col xl:flex-row items-center justify-center gap-0 mb-[60px] xl:mb-[80px]"
            data-aos="fade-up"
            data-aos-delay={250}
          >
            {logistics_section4_amazon_data.process.map((p, i) => (
              <div key={i} className="flex xl:flex-row flex-col items-center">
                <div className="flex flex-col items-center justify-center bg-white border-[2px] border-[#00528C] rounded-[16px] w-[200px] xl:w-[220px] py-[28px] px-[20px] text-center shadow-[0_4px_24px_0_#00528C1A]">
                  <span className="text-[#00528C] text-[13px] font-bold tracking-[0.12em] mb-[8px]">{p.step}</span>
                  <span className="text-[#00528C] text-[11px] font-semibold tracking-[0.08em] uppercase mb-[4px]">{p.labelEn}</span>
                  <span className="text-[#132648] text-[18px] xl:text-[20px] font-semibold leading-[28px] mb-[6px]">{p.label}</span>
                  <span className="text-[#888] text-[13px] leading-[20px]">{p.detail}</span>
                </div>
                {i < logistics_section4_amazon_data.process.length - 1 && (
                  <div className="text-[#00528C] text-[28px] xl:text-[36px] font-light xl:mx-[12px] my-[8px] xl:my-0 select-none">›</div>
                )}
              </div>
            ))}
          </div>

          {/* 4가지 기능 카드 */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-[20px] xl:gap-[28px]">
            {logistics_section4_amazon_data.features.map((f, i) => (
              <div
                key={i}
                className="bg-white rounded-[16px] p-[32px] xl:p-[40px] shadow-[0_4px_24px_0_#00000010] flex flex-col gap-[12px] border border-[#E8EEF4]"
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <span className="text-[36px]">{f.icon}</span>
                <div className="text-[#00528C] text-[12px] font-semibold tracking-[0.08em] uppercase">{f.titleEn}</div>
                <div className="text-[#132648] text-[20px] xl:text-[22px] font-semibold leading-[32px]">{f.title}</div>
                <div className="text-[#666] text-[15px] xl:text-[16px] leading-[26px]">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 5: 가격 정책 */}
      <section id="section5" className="bg-white pt-[80px] xl:pt-[140px] pb-[80px] xl:pb-[140px]">
        <div className="INSIDE">
          <div className="flex flex-col items-center text-center mb-[60px] xl:mb-[80px]">
            <div
              className="text-[#00528C] text-[14px] xl:text-[16px] font-semibold uppercase tracking-[0.1em] mb-[16px]"
              data-aos="fade-up"
            >
              {logistics_section5_pricing_data.subtitle}
            </div>
            <h2
              className="font-semibold text-[32px] leading-[44px] xl:text-[56px] xl:leading-[68px] text-[#132648] mb-[20px]"
              data-aos="fade-up"
              data-aos-delay={100}
            >
              {logistics_section5_pricing_data.title}
            </h2>
            <p
              className="text-[#555] text-[15px] leading-[26px] xl:text-[18px] xl:leading-[30px] max-w-[680px] whitespace-pre-line"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              {logistics_section5_pricing_data.description}
            </p>
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-2 gap-[24px] xl:gap-[40px] max-w-[900px] mx-auto mb-[40px]">
            {logistics_section5_pricing_data.plans.map((plan, i) => (
              <div
                key={i}
                className={`rounded-[20px] p-[36px] xl:p-[48px] flex flex-col gap-[28px] border-[2px] ${
                  plan.highlight
                    ? 'bg-[#132648] border-[#132648] text-white shadow-[0_8px_40px_0_#13264840]'
                    : 'bg-white border-[#E0E8F0] text-[#132648]'
                }`}
                data-aos="fade-up"
                data-aos-delay={i * 150}
              >
                <div>
                  <div className={`text-[13px] font-semibold tracking-[0.1em] uppercase mb-[4px] ${plan.highlight ? 'text-[#7BB8E8]' : 'text-[#00528C]'}`}>
                    {plan.nameEn}
                  </div>
                  <div className={`text-[15px] font-bold mb-[12px] ${plan.highlight ? 'text-white' : 'text-[#132648]'}`}>
                    {plan.name}
                  </div>
                  <div className={`text-[48px] xl:text-[56px] font-bold leading-[1] mb-[4px] ${plan.highlight ? 'text-white' : 'text-[#132648]'}`}>
                    {plan.price}
                  </div>
                  <div className={`text-[14px] ${plan.highlight ? 'text-[#7BB8E8]' : 'text-[#888]'}`}>
                    {plan.priceDetail}
                  </div>
                </div>
                <div className={`w-full h-[1px] ${plan.highlight ? 'bg-[#ffffff20]' : 'bg-[#E0E8F0]'}`} />
                <ul className="flex flex-col gap-[14px]">
                  {plan.features.map((feat, j) => (
                    <li key={j} className={`flex items-start gap-[10px] text-[15px] xl:text-[16px] leading-[24px] ${plan.highlight ? 'text-[#C8DFF0]' : 'text-[#444]'}`}>
                      <span className={`mt-[4px] flex-shrink-0 w-[16px] h-[16px] rounded-full flex items-center justify-center text-[10px] font-bold ${plan.highlight ? 'bg-[#00528C] text-white' : 'bg-[#E8F0F8] text-[#00528C]'}`}>✓</span>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p
            className="text-center text-[13px] xl:text-[14px] text-[#999] leading-[22px]"
            data-aos="fade-up"
          >
            {logistics_section5_pricing_data.note}
          </p>
        </div>
      </section>

      <section className="bg-white py-[40px] w-full shadow-[0_0_20px_0_#00000033]">
        <div className="INSIDE relative flex flex-col xl:flex-row xl:items-center justify-between gap-[20px] xl:gap-0">
          <div className="font-semibold text-[20px] leading-[28px]">도움이 필요하다면?<br />이커머스에 관한 모든것을 문의하세요</div>
          <Link className={`BTN BTN-BLACK w-[132px]`} onClick={(evt) => {
                $('#mobileGnb').INACTIVE();
                dispatch(openInquiryLayer());
              }}>Contact</Link>
        </div>
      </section>
    </div>
  );
}

export default PageLogistics;